import React from 'react'
import { Controller } from 'react-hook-form'
import { TextField, Grid, Box, Typography, Divider } from '@material-ui/core'

import { BasePhoneInput } from 'components'

import helpers from 'helpers'

const Commissioner = ({ errors, control, isShow = false }) => {
  return (
    <>
      <Grid item xs={12}>
        <Box mb={2}>
          <Typography variant="h6">
            Dados do encarregado pelo tratamento de dados pessoais
          </Typography>
        </Box>
        <Divider />
      </Grid>
      <Grid item md={6} xs={12}>
        <Box mt={2}>
          <Controller
            as={
              <TextField
                label="Nome da Empresa"
                type="text"
                color="primary"
                variant="outlined"
                error={!!errors.nameCommissioner}
                helperText={errors?.nameCommissioner?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="nameCommissioner"
            mode="onBlur"
          />
        </Box>
      </Grid>
      <Grid item md={6} xs={12}>
        <Box mt={2}>
          <Controller
            as={
              <TextField
                label="CNPJ / CPF"
                type="text"
                color="primary"
                variant="outlined"
                error={!!errors.documentCommissioner}
                helperText={errors?.documentCommissioner?.message}
                fullWidth
                disabled={isShow}
              />
            }
            onChange={([text]) =>
              helpers.formatters.document.identify(text.target.value, true)
            }
            control={control}
            name="documentCommissioner"
            mode="onBlur"
          />
        </Box>
      </Grid>
      <Grid item md={6} xs={12}>
        <Box mt={2}>
          <Controller
            as={
              <BasePhoneInput
                label="Telefone"
                error={!!errors.phoneCommissioner}
                helperText={errors?.phoneCommissioner?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="phoneCommissioner"
            mode="onChange"
          />
        </Box>
      </Grid>
      <Grid item md={6} xs={12}>
        <Box mt={2}>
          <Controller
            as={
              <TextField
                label="E-mail"
                type="email"
                color="primary"
                variant="outlined"
                error={!!errors.emailCommissioner}
                helperText={errors?.emailCommissioner?.message}
                fullWidth
                disabled={isShow}
              />
            }
            control={control}
            name="emailCommissioner"
            mode="onBlur"
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box py={2}>
          <Divider />
        </Box>
      </Grid>
    </>
  )
}

export default Commissioner
